const authDataKey = 'mobile-counter-pos-auth-data';

function loggedIn() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return data.token !== null;
    }

    return false;
}

function setData(data) {
    localStorage.setItem(authDataKey, JSON.stringify(data));
}

function setProfileData(val) {
    let token = getToken()
    let is_have_pin = getUserHavePin()
    let data = {
        token: token,
        pos: val,
        is_have_pin: is_have_pin,
    }
    localStorage.setItem(authDataKey, JSON.stringify(data));
}

function getUserData() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return data.pos;
    }

    return null;
}

function getToken() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return data.token;
    }

    return null;
}

function clearData() {
    localStorage.removeItem(authDataKey);
}

function getUserHavePin() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return data.is_have_pin;
    }

    return false;
}

function updatePin(pin) {
    let token = getToken()
    let pos = getUserData()
    let data = {
        token: token,
        pos: pos,
        is_have_pin: pin,
    }
    localStorage.setItem(authDataKey, JSON.stringify(data));
}

export default {
    loggedIn,
    setData,
    setProfileData,
    getUserData,
    getToken,
    clearData,
    getUserHavePin,
    updatePin,
};